export default __webpack_public_path__ + "static/bg-uk-react-native-3b798975cac0b24f6ebc411a9ab72ebd.webp";